import React from 'react';
import { Card } from '@innovationnorway/component-library';
import { sanitizeD365RichTextEditor } from '../../../utils/htmlTextConverter';

type Props = {
  note: string;
};

const RecommendServiceMailCustomer: React.FC<Props> = ({ note }) => {
  return (
    <Card className="email-preview padding--2 stack-medium font-size--medium">
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeD365RichTextEditor(note),
        }}
      ></div>
    </Card>
  );
};

export default RecommendServiceMailCustomer;
